import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { AnchorModel } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';
import { Subscription, fromEvent, merge } from 'rxjs';

@Component({
  selector: 'app-page-general',
  templateUrl: './page-general.component.html',
  styleUrls: ['./page-general.component.scss']
})
export class PageGeneralComponent implements OnInit {

  @ViewChild('header') header!: ElementRef;
  @ViewChild('modalShare') modalShare: any;
  @Input() node: any;
  @Input() anchorItems: AnchorModel[] = [];
  @Input() isSecondLevelUp: boolean = false;
  @Input() levelMenu: any;
  public isShowLocalMenu: any;
  public idAnchor: string = '';
  public block: any;
  public domainWebsite = environment.urlApi;
  public imgPath = "";
  public isSpinner: boolean = false;
  public titlePage: string = '';
  public eliminaVisualizzazione: boolean = false;
  public eliminaField: boolean = false;
  public columnFieldTaxonomies: string = '';
  public searchItems: any;
  public onHoverShare: boolean = false;
  public isCollapseHeader: boolean = false;
  public isCollapseHeader2: boolean = false;
  public dataFieldTaxonomies: any[] = [];
  public dataFieldTaxonomies_2: any[] = [];
  public dataFieldTaxonomies_3: any[] = [];
  public contentTypes: {type: string, condition: boolean, data: any}[] = [];
  public isLoading = true;
  private subscriptionMouseMove: Subscription = new Subscription();
  public rows: any = [];

  constructor(
    private helpersService: HelpersService,
    public nodeService: NodeService
  ) { }

  ngOnInit(): void {
    if (this.node && this.node.title && this.node.title[0] && this.node.title[0].value === 'Homepage') {
      this.rows = this.node.field_layout_righe.slice(0,1);
      if (this.helpersService.isBrowser) {        
        this.subscriptionMouseMove = merge(
          fromEvent(document, 'mousemove'),
          fromEvent(document, 'touchmove'),
          fromEvent(document, 'scroll'),
        ).subscribe((event: Event)=> {
          if (this.isLoading) {
            this.isLoading = false;
            this.rows = this.node.field_layout_righe;
            this.subscriptionMouseMove.unsubscribe();
          }
        });
      }
    } else {
      this.rows = this.node.field_layout_righe;
    }
    this.getRowTypeView();
    this.isSpinner = true;
    this.nodeService.searchItems$.subscribe(items => {
      this.searchItems = items;
    });
    this.helpersService.showLocalMenuBS.subscribe(value => {
      this.isShowLocalMenu = value;
    });
  }

  ngOnDestroy() {
    this.subscriptionMouseMove.unsubscribe();
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    // FIRST LEVEL
    let boundingCollapse;
    if (!this.isSecondLevelUp && this.isSpinner && this.node) {      
        boundingCollapse = document.querySelector('.container-page-general')?.getBoundingClientRect();
      if ((boundingCollapse && boundingCollapse.y < -450 && boundingCollapse.width > 767) || 
          (boundingCollapse && boundingCollapse.y < -200 && boundingCollapse.width <= 767)) {
        this.isCollapseHeader = true;
      } else {
        this.isCollapseHeader = false;
      }
    }
    // SECOND LEVEL
    let boundingCollapse2;
    if (this.isSecondLevelUp && this.isSpinner && this.node) {
      // SE HA LE TASSONOMIE
      boundingCollapse2 = document.querySelector('.container-field-taxonomies')?.getBoundingClientRect();
      if (!boundingCollapse2) {
        //SE NON HA LE TASSONOMIE
        boundingCollapse2 = document.getElementById('collapse-2')?.getBoundingClientRect();
      }
      if (this.isSecondLevelUp && this.block && !this.block.field_immagine && 
          (boundingCollapse2 && boundingCollapse2.y < -40 && boundingCollapse2.width > 767) || 
          (boundingCollapse2 && boundingCollapse2.y < -200 && boundingCollapse2.width <= 767)) {
        this.isCollapseHeader2 = true;
      } else if (this.isSecondLevelUp && this.block && this.block.field_immagine && 
                (boundingCollapse2 && boundingCollapse2.y < -490 && boundingCollapse2.width > 767) || 
                (boundingCollapse2 && boundingCollapse2.y < -200 && boundingCollapse2.width <= 767)) {
        this.isCollapseHeader2 = true;
      } else {
        this.isCollapseHeader2 = false;
      }
    }
  }


  private getRowTypeView(): void {
    this.nodeService.getRowTypeView(this.node.langcode[0].value, this.node.field_oggetto_view[0].value, this.node.field_tipo_view[0].value, this.node.preview, this.node.nid[0].value).subscribe(resView => {
      this.block = resView[0];
      this.setDataFields(this.block);
      this.contentTypes = [
        { type: 'default', condition: !this.node.field_corso_di_lingua_aperto_a.length && !this.node.field_area_attivita.length && this.node.field_elimina_visualizzazione_ca && this.node.field_elimina_visualizzazione_ca.length && !this.node.field_elimina_visualizzazione_ca[0].value, data: this.dataFieldTaxonomies },
        { type: 'language', condition: this.node.field_corso_di_lingua_aperto_a.length && !this.node.field_area_attivita.length && this.node.field_elimina_visualizzazione_ca && this.node.field_elimina_visualizzazione_ca.length && !this.node.field_elimina_visualizzazione_ca[0].value, data: this.dataFieldTaxonomies_2 },
        { type: 'others', condition: this.node.field_area_attivita.length && this.node.field_elimina_visualizzazione_ca && this.node.field_elimina_visualizzazione_ca.length && !this.node.field_elimina_visualizzazione_ca[0].value, data: this.dataFieldTaxonomies_3 }
      ];
      this.imgPath = this.domainWebsite + this.helpersService.retrieveImage(this.block.field_immagine, "src");
      this.titlePage = this.helpersService.retriveLinkTagA(this.block.field_titolo, 'a').title;
    });
  }

  addNewAnchorItem(value: AnchorModel): void {
    if (value.labelRow !== '') {
      this.anchorItems.push(value);
    }
    this.anchorItems.sort((a, b) => a.position - b.position);
    // this.idAnchor = this.anchorItems[0].idRow;
  }


  public openMenu(): void {
    this.helpersService.openLocalMenuBS.next(true);
  }

  private addDataField(array: any[], title: string, value: any, isArray: boolean) {
    if (value && value.length > 0) {
      array.push({
        titolo: title,
        value: isArray ? value : value[0].value,
        isArray: isArray
      });
    }
  }
  
  private setDataFields(block: any): void {
    this.addDataField(this.dataFieldTaxonomies, 'CONTENT_TYPES.PAGE_GENERAL.DEPARTMENT', block.field_tassonomia_dipartimento, true);
    this.addDataField(this.dataFieldTaxonomies, 'CONTENT_TYPES.PAGE_GENERAL.DEGREE_COURSES', block.field_tassonomia_corsi_di_laurea, true);
    this.addDataField(this.dataFieldTaxonomies, 'CONTENT_TYPES.PAGE_GENERAL.UNIVERSITY_AREAS', block.field_tassonomia_area_universita, true);
  
    this.addDataField(this.dataFieldTaxonomies_2, 'CONTENT_TYPES.PAGE_GENERAL.UNIVERSITY_AREAS', block.field_tassonomia_area_universita, true);
    this.addDataField(this.dataFieldTaxonomies_2, 'CONTENT_TYPES.PAGE_GENERAL.DEPARTMENT', block.field_tassonomia_dipartimento, true);
    this.addDataField(this.dataFieldTaxonomies_2, 'CONTENT_TYPES.PAGE_ALLOGGIO.CITY', this.node.field_citta_corso, false);
    this.addDataField(this.dataFieldTaxonomies_2, 'CONTENT_TYPES.PAGE_GENERAL.REFERENCE_PERIOD', this.node.field_periodo_di_riferimento_cor, false);
    this.addDataField(this.dataFieldTaxonomies_2, 'CONTENT_TYPES.PAGE_GENERAL.LANGUAGE', this.node.field_lingua_corso, true);
    this.addDataField(this.dataFieldTaxonomies_2, 'CONTENT_TYPES.PAGE_GENERAL.COURSE_OPEN_TO', this.node.field_corso_di_lingua_aperto_a, false);
  
    this.addDataField(this.dataFieldTaxonomies_3, 'CONTENT_TYPES.PAGE_GENERAL.DEPARTMENT', block.field_tassonomia_dipartimento, true);
    this.addDataField(this.dataFieldTaxonomies_3, 'CONTENT_TYPES.PAGE_GENERAL.DEGREE_COURSES', block.field_tassonomia_corsi_di_laurea, true);
    this.addDataField(this.dataFieldTaxonomies_3, 'CONTENT_TYPES.PAGE_GENERAL.UNIVERSITY_AREAS', block.field_tassonomia_area_universita, true);
    this.addDataField(this.dataFieldTaxonomies_3, 'CONTENT_TYPES.PAGE_GENERAL.ACTIVITY_AREAS', this.node.field_area_attivita, false);
    this.addDataField(this.dataFieldTaxonomies_3, 'CONTENT_TYPES.PAGE_GENERAL.REFERENCE_PERIOD', this.node.field_periodo_di_riferimento_alt, false);
  }
  
}
